const HIDDEN_REPO_IDENTIFIERS = [
  // Add repo full names or names to hide from the Projects UI.
  // Examples:
  // "LiveBacteria/WordVec",
  // "WordVec",
  "Spiking-Neural-Simulator-A-Hypermap-Implementation",
  "QNNF-Neural-Networks-as-a-Fundamental-Physics-System",
  "QNMF-Encryption-and-Compression",
  "MagicTime-Game",
];

const envHidden = (process.env.REACT_APP_HIDE_REPOS || "")
  .split(",")
  .map((item) => item.trim())
  .filter(Boolean);

const hiddenSet = new Set(
  [...HIDDEN_REPO_IDENTIFIERS, ...envHidden].map((value) =>
    value.toLowerCase(),
  ),
);

const isRepoVisible = (repo) => {
  const fullName = (repo?.full_name || "").toLowerCase();
  const repoName = (repo?.name || "").toLowerCase();

  return !hiddenSet.has(fullName) && !hiddenSet.has(repoName);
};

export { HIDDEN_REPO_IDENTIFIERS, isRepoVisible };
